export const screenerCopyIt = {
    start: "Inizia",
    starting: "Avvio in corso...",
    checking: "Stiamo controllando le tue risposte...",
    notFoundTitle: "Questo link non funziona",
    notFoundBody: "Il questionario potrebbe essere chiuso. Contatta il team che ti ha dato questo link.",
    eligibleTitle: "Puoi partecipare",
    eligibleBody: "Crea il tuo account per iniziare.",
    ineligibleTitle: "Questo programma non fa per te",
    ineligibleBody:
        "Grazie per le tue risposte. In base alle tue risposte, non soddisfi i criteri. Per qualsiasi domanda, contatta il team che ti ha dato questo link.",
    continueToSignUp: "Continua con la registrazione",
    scanOnPhone: "Oppure scansiona questo codice con la fotocamera del telefono per registrarti dal telefono.",
    startAgain: "Ricomincia",
};
